<template>
  <div class="live2d">
    <div class="bg"></div>
    <div id="__spine_player_container__"></div>
    <div class="mask" :data-map-type="dataSource.source.type" :data-map-key="dataSource.source.key">
      <div class="empty" v-if="isEmpty && !loading">
        <img src="@/assets/zs_imgs/empty-img.png" alt="" />
        <div>资料暂时空缺，留言让版主加急</div>
      </div>
      <div class="loading" v-if="loading">
        <div class="loader">
          <span class="item"></span>
          <span class="item"></span>
          <span class="item"></span>
          <span class="item"></span>
        </div>
        <div class="text">正在加载中哦</div>
      </div>
      <div class="btns">
        <div class="btn" :data-map-type="dataSource.lh.type" :data-map-key="dataSource.lh.key" @click="openLh">
          <img src="@/assets/zs_imgs/image-icon.png" alt="" />
        </div>
        <div class="btn" @click="openLive2d">
          <img src="@/assets/zs_imgs/view-icon.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 显示立绘 -->
    <el-dialog
      title=""
      fullscreen
      append-to-body
      custom-class="lh-dialog"
      :visible.sync="lhVisible"
      :after-close="closeLh"
    >
      <div class="lh-container">
        <img :src="dataSource.lh.value" alt="" />
      </div>
    </el-dialog>

    <!-- 显示live2d -->
    <el-dialog
      title=""
      fullscreen
      append-to-body
      custom-class="live2d-dialog"
      :visible.sync="live2dVisible"
      :after-close="closeLive2d"
    >
      <div class="live2d-container" id="__dialog_spine_player_container__"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      lhVisible: false,
      live2dVisible: false,
      loading: false,
      isEmpty: false
    };
  },
  watch: {
    dataSource: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.loading = true;
          this.initSpine("__spine_player_container__");
        });
      },
      deep: true
    }
  },
  mounted() {
    // console.log(222, this.data);
    this.loading = true;
    this.initSpine("__spine_player_container__");
  },
  methods: {
    initSpine(container) {
      const data = this.dataSource.source.value;

      if (typeof data === "object") {
        if (!data.json) {
          this.loading = false;
          return;
        }
        this.isEmpty = false;
        const _this = this;
        // 先获取到spine可执行的动画
        fetch(data.json)
          .then(response => response.json())
          .then(json => {
            const animations = Object.keys(json.animations);
            document.querySelector("#" + container).innerHTML = null;
            // 初始化
            // eslint-disable-next-line
            new window.spine.SpinePlayer(container, {
              // Relative URLs
              jsonUrl: this.foramtUrl(data.json),
              atlasUrl: this.foramtUrl(data.atlas),
              animations: animations,
              showLoading: false,
              showControls: false,
              alpha: true,
              backgroundColor: "#00000000",
              success: function(player) {
                _this.loading = false;
                _this.isEmpty = false;
              }
            });
          })
          .catch(() => {
            this.isEmpty = true;
          });
      } else if (data) {
        this.loading = false;
        this.isEmpty = false;
        document.querySelector("#" + container).innerHTML = `<img class="lh-img" src="${data}" alt="" />`;
      } else {
        this.loading = false;
        this.isEmpty = true;
      }
    },
    foramtUrl(url) {
      if (url.startsWith("//")) {
        return `${location.protocol}${url}`;
      } else {
        return url;
      }
    },
    openLh() {
      console.log(1);
      this.lhVisible = true;
    },
    closeLh() {
      this.lhVisible = false;
    },
    openLive2d() {
      this.live2dVisible = true;
      this.initSpine("__dialog_spine_player_container__");
    },
    closeLive2d() {
      this.live2dVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #e4e4e4;
  line-height: 14px;
  margin-top: -100px;
  img {
    width: 190px;
    height: 163px;
    margin-bottom: 7px;
  }
}
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  color: #e4e4e4;
  line-height: 14px;
  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 20px;
    .item {
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background: #4f6cc2;
      animation: ball-beat 0.7s -0.15s infinite linear;
      &:nth-child(2n-1) {
        animation-delay: -0.5s;
      }
    }

    @keyframes ball-beat {
      50% {
        opacity: 0.2;
        transform: scale(0.75);
      }

      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.live2d {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 638px;
  /deep/ #__spine_player_container__ {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 380px;
      max-height: 100%;
    }
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 638px;
    background: url("~@/assets/zs_imgs/live2d-box-bg.png");
    background-size: 100% 100%;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: #ffffff00;
    color: #ffffff00;
    display: flex;
    align-items: center;
    justify-content: center;
    .btns {
      position: absolute;
      right: 0;
      top: 21px;
      width: 68px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 14px;
    }
    .btn {
      display: inline-block;
      width: 27px;
      height: 27px;
      background: rgba(0, 0, 0, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 18px;
        height: 18px;
      }
    }
  }
}

/deep/ .lh-dialog {
  background-color: rgba(0, 0, 0, 0.77);
  .el-dialog__header {
    position: relative;
    padding: 0;
    margin: 0 auto;
    width: 1000px;
    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
    .el-icon-close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .lh-container {
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    text-align: center;
    img {
      height: 100%;
    }
  }
}

/deep/ .live2d-dialog {
  background-color: rgba(0, 0, 0, 0.9);
  .el-dialog__header {
    position: relative;
    padding: 0;
    margin: 0 auto;
    width: 1000px;
    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
    .el-icon-close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .live2d-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    text-align: center;
  }
}
</style>
